import * as React from "react";
import {
    PlasmicIFrame,
    DefaultIFrameProps
} from "./plasmic/main/PlasmicIFrame";
import {useParams} from "react-router-dom";

export interface IFrameProps extends DefaultIFrameProps {
    user?: any
}

function IFrame({user, ...rest}: IFrameProps) {
    let params = useParams();
    const noteID = params.noteID;

    return <PlasmicIFrame
        {...rest}
        canvasView={{
            noteID: noteID,
            user: user
        }}
        />;
}

export default IFrame;
